<template>
  <main-layout>
    <template #nav>
      <div class="flex flex-wrap items-center justify-between mx-auto">
        <h1 class="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">'NaNi</h1>
      </div>
    </template>
    <div class="grid h-screen place-items-center">
      <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div class="mx-auto max-w-screen-sm text-center">
          <h1 class="mb-4 text-2xl font-bold tracking-tight text-gray-900">
            Page not found
          </h1>
          <h2 class="mb-4 tracking-tight text-gray-500">
            Sorry, we can't find that page. You'll find lots to explore on the
            home page.
          </h2>
          <router-link
            :to="{
              name: 'Home',
              query: {
                token: Jwt,
              },
            }"
            class="inline-flex text-secondary-600 bg-primary-600 hover:bg-primary-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4">Back
            to Homepage</router-link>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script setup>
import { useAccountStore } from '@/stores/account';
import { computed } from 'vue';

import MainLayout from '@/layouts/MainLayout.vue';

const Jwt = computed(() => useAccountStore().Jwt);

</script>
